import React from "react";
import "./style.css";

const DrawingLayout = ({ children }) => {
  return <main className="drawing-layout">{children}</main>;
};

export default DrawingLayout;
